// removed by extract-text-webpack-plugin
module.exports = {"root":"d8Uxvnz4Q4zKLYsH3p_oD","nprogress-spinner":"d2OIbxex_P2bYceL8eLwS"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"/"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6091f77c","scoped":false,"hasInlineConfig":false}!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./src/gotu-vue-common/src/components/progress-bar/ProgressBar.scss
// module id = 981
// module chunks = 1